// This mixin contains code that is used for both gas and electricity non half hourly readings
import { _ } from 'underscore';
import moment from 'moment';

export default {
  props: {
    meterSerialFilter: {
      type: String,
      required: true,
    },
    showExcludedReadings: {
      type: Boolean,
      required: true,
    },
    showOnlyCustomer: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    customer() {
      return this.$store.state.customers.customer;
    },
    meters() {
      return this.$store.state.meters.activeService.Meters;
    },
    readings() {
      return this.$store.state.meters.activeService.Readings;
    },
    bills() {
      return this.$store.state.finances.bills;
    },
    contractsByServiceIdentifier() {
      return this.$store.state.meters.contractsByServiceIdentifier;
    },
    tenancies() {
      return this.$store.state.meters.activeService.Tenancies;
    },
    customerTenancies() {
      const tenancies = this.tenancies || [];
      const customerReference =
        this.customer && this.customer.CustomerReference;
      if (!customerReference) return [];
      return tenancies.filter((t) => t.CustomerReference === customerReference);
    },
    MEXs() {
      let mexReadings = [];
      this.meters.forEach((meter) => {
        meter.MeterConfigs.forEach((meterConfig) => {
          if (meterConfig.hasOwnProperty('EffectiveFrom')) {
            mexReadings.push(
              moment(meterConfig.EffectiveFrom).format('YYYY.MM.DD')
            );
          }
          if (meterConfig.hasOwnProperty('EffectiveTo')) {
            mexReadings.push(
              moment(meterConfig.EffectiveTo).format('YYYY.MM.DD')
            );
          }
        });
      });
      return _.uniq(mexReadings);
    },
    COTs() {
      if (!this.tenancies) return [];

      return this.tenancies
        .filter((t) => t.AcquisitionType === 'Transferred')
        .map(({ EffectiveFrom }) => moment(EffectiveFrom).format('YYYY.MM.DD'));
    },
    COSs() {
      if (!this.tenancies) return [];

      return this.tenancies
        .filter(
          (t) => 'Registered' == t.AcquisitionType || 'Lost' == t.ReleaseType
        )
        .map((t) => {
          const date =
            t.ReleaseType === 'Lost'
              ? moment(t.EffectiveTo).add(1, 'days')
              : moment(t.EffectiveFrom);

          return date.format('YYYY.MM.DD');
        });
    },
    filteredReadings() {
      let readings = this.readings;

      readings = this.showExcludedReadings
        ? readings
        : this.filterByExcludedReadings(readings);
      readings =
        this.meterSerialFilter === 'All'
          ? readings
          : this.filterByMeterSerial(readings);
      readings = this.showOnlyCustomer
        ? this.filterByCustomer(readings)
        : readings;

      // Filter out duplicate reads when the same read and date exists more than once
      readings = readings.map(reading => ({
        ...reading,
        RegisterReadings: this.deduplicateRegisterReadings(reading.RegisterReadings)
      }));

      return /*this.showOnlyCustomer? readings.splice(0,2):*/ readings;
    },
  },
  methods: {
    billingInfo(invoice) {
      return _.where(this.bills, {
        InvoiceNumber: invoice,
      });
    },

    filterByExcludedReadings(readings) {
      return _.filter(readings, function(reading) {
        // Only filter out if all three conditions are met:
        // (Invalid or Failed) AND no AssociatedInvoices AND DoNotBill is true
          if (
         (!reading.AssociatedInvoices || reading.AssociatedInvoices.length === 0) &&
          reading.DoNotBill
        ) {
          return false;
        }
        return true;
      });
    },

    filterByMeterSerial(readings) {
      let serial = this.meterSerialFilter;
      return _.where(readings, {
        Serial: serial,
      });
    },

    filterByCustomer(readings) {
      if (!this.customerTenancies.length) return [];

      return readings.filter((r) =>
        this.customerTenancies.some((t) =>
          moment(r.ReadingDate).isBetween(
            t.EffectiveFrom,
            t.ReleaseType === 'Lost' ? moment(t.EffectiveTo).add(1, 'day'): t.EffectiveTo,
            'days',
            '[]'
          )
        )
      );
    },

    toggleObject(item) {
      this.$store.commit('updateReadingsToggle', item);
    },

    deduplicateRegisterReadings(registerReadings) {
      if (!registerReadings || registerReadings.length === 0) return [];
      
      const uniqueReadings = new Map();
      
      registerReadings.forEach(reading => {
        // Create key based on MeterRegisterId and Reading value
        const key = `${reading.MeterRegisterId}-${reading.Reading}`;
        
        if (!uniqueReadings.has(key)) {
          // First occurrence - keep it
          uniqueReadings.set(key, reading);
        } else {
          // Duplicate found - keep the one with IsValid: true if available
          const existing = uniqueReadings.get(key);
          if (reading.IsValid && !existing.IsValid) {
            uniqueReadings.set(key, reading);
          }
        }
      });
      
      return Array.from(uniqueReadings.values());
    },

    getRowStyle(item, type) {
      if (!item || type !== 'row') return;
      if (this.COSs.includes(moment(item.ReadingDate).format('YYYY.MM.DD')))
        return 'cosReading';
      if (this.COTs.includes(moment(item.ReadingDate).format('YYYY.MM.DD')))
        return 'cotReading';
      if (this.MEXs.includes(moment(item.ReadingDate).format('YYYY.MM.DD')))
        return 'mexReading';
    },
  },
};
